(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/react/carousel-item.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/react/carousel-item.js');

'use strict';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const clx = svs.components.lbUtils.clx;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM;
const CarouselItem = _ref => {
  let children = _ref.children,
    isHidden = _ref.isHidden,
    isPlaceholder = _ref.isPlaceholder,
    isSelected = _ref.isSelected,
    roleDescription = _ref.roleDescription;
  const isMobileQuery = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const carouselItemRef = useRef(null);
  const selectors = ['a[href]:not([disabled])', 'button:not([disabled])', 'textarea:not([disabled])', 'input[type="text"]:not([disabled])', 'input[type="radio"]:not([disabled])', 'input[type="checkbox"]:not([disabled])', 'select:not([disabled])', ':scope [tabindex]:not([disabled])'].join(',');
  const toggleHidden = useCallback(isHidden => {
    const item = carouselItemRef.current;
    if (isPlaceholder || !item) {
      return;
    }
    if (isHidden || isPlaceholder) {
      item.setAttribute('aria-hidden', 'true');
      item.setAttribute('inert', '');
    } else {
      item.setAttribute('aria-hidden', 'false');
      item.removeAttribute('inert');
    }
    if (isHidden) {
      item.classList.add('carousel-item-hidden');
      const elements = [...item.querySelectorAll(selectors)];
      for (const element of elements) {
        element.classList.add('carousel-item-unfocusable');
        if (isMobileQuery) {
          if (element.hasAttribute('tabindex')) {
            element.dataset.tab = element.tabIndex;
          }
          element.setAttribute('tabindex', '-1');
        }
      }
    } else {
      item.classList.remove('carousel-item-hidden');
      const elements = [...item.querySelectorAll('.carousel-item-unfocusable')];
      for (const element of elements) {
        element.classList.remove('carousel-item-unfocusable');
        if (isMobileQuery) {
          if (element.hasAttribute('data-tab')) {
            element.setAttribute('tabindex', element.dataset.tab);
          } else {
            element.removeAttribute('tabindex');
          }
        }
      }
    }
  }, [isMobileQuery, isPlaceholder, selectors]);
  useEffect(() => {
    const item = carouselItemRef.current;
    const callback = entries => entries.forEach(entry => toggleHidden(!entry.isIntersecting));
    const observer = new IntersectionObserver(callback, {
      root: item === null || item === void 0 ? void 0 : item.parentElement,
      threshold: 0.9
    });
    observer.observe(item);
    return () => {
      observer.unobserve(item);
    };
  }, [toggleHidden]);
  return React.createElement("div", _extends({
    "aria-hidden": isHidden || isPlaceholder,
    "aria-roledescription": roleDescription,
    className: clx('carousel-item', {
      'carousel-item-placeholder': isPlaceholder,
      'carousel-item-selected': isSelected,
      'carousel-item-hidden': isHidden || isPlaceholder
    }),
    ref: carouselItemRef,
    role: "listitem"
  }, isHidden || isPlaceholder ? {
    inert: ''
  } : {}, isMobileQuery ? {
    tabIndex: -1
  } : {}), React.createElement("div", {
    className: "carousel-item-inner"
  }, children));
};
setGlobal('svs.components.lbUi.carousel.CarouselItem', CarouselItem);

 })(window);